// Locality → postcode mapping for the Warren-Blackwood electorate.
// Sourced from Australia Post locality data (PostcodeFinder), six LGAs.
// Keys are upper-cased plain locality names (no "(WA)" suffix) to match
// the polygon feature.properties.name format used elsewhere in the app.

export interface PostcodeEntry {
  /** Pretty display name, e.g. "Margaret River". */
  name: string;
  /** 4-digit AU postcode as a string (preserves any leading zero). */
  postcode: string;
  /** Full LGA name, e.g. "Shire of Augusta-Margaret River". */
  lga: string;
}

/** Raw rows from the supplied CSV — order preserved for stable iteration. */
export const LOCALITY_POSTCODES: PostcodeEntry[] = [
  { name: 'Alexandra Bridge', postcode: '6288', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Augusta', postcode: '6290', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Baudin', postcode: '6284', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Boranup', postcode: '6286', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Bramley', postcode: '6285', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Burnside', postcode: '6285', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Courtenay', postcode: '6288', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Cowaramup', postcode: '6284', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Deepdene', postcode: '6290', lga: 'Shire of Augusta-Margaret River' },
  { name: 'East Augusta', postcode: '6290', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Forest Grove', postcode: '6286', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Gnarabup', postcode: '6285', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Gracetown', postcode: '6284', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Hamelin Bay', postcode: '6288', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Karridale', postcode: '6288', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Kudardup', postcode: '6290', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Leeuwin', postcode: '6290', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Margaret River', postcode: '6285', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Molloy Island', postcode: '6290', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Nillup', postcode: '6288', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Osmington', postcode: '6285', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Prevelly', postcode: '6285', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Redgate', postcode: '6286', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Rosa Brook', postcode: '6285', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Rosa Glen', postcode: '6285', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Schroeder', postcode: '6285', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Scott River', postcode: '6288', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Treeton', postcode: '6284', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Warner Glen', postcode: '6288', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Witchcliffe', postcode: '6286', lga: 'Shire of Augusta-Margaret River' },

  { name: 'Benjinup', postcode: '6255', lga: 'Shire of Boyup Brook' },
  { name: 'Boyup Brook', postcode: '6244', lga: 'Shire of Boyup Brook' },
  { name: 'Chowerup', postcode: '6244', lga: 'Shire of Boyup Brook' },
  { name: 'Dinninup', postcode: '6244', lga: 'Shire of Boyup Brook' },
  { name: 'Kulikup', postcode: '6244', lga: 'Shire of Boyup Brook' },
  { name: 'Mayanup', postcode: '6244', lga: 'Shire of Boyup Brook' },
  { name: 'McAlinden', postcode: '6225', lga: 'Shire of Boyup Brook' },
  { name: 'Scotts Brook', postcode: '6244', lga: 'Shire of Boyup Brook' },
  { name: 'Tonebridge', postcode: '6244', lga: 'Shire of Boyup Brook' },
  { name: 'Wilga', postcode: '6243', lga: 'Shire of Boyup Brook' },

  { name: 'Bridgetown', postcode: '6255', lga: 'Shire of Bridgetown-Greenbushes' },
  { name: 'Catterick', postcode: '6255', lga: 'Shire of Bridgetown-Greenbushes' },
  { name: 'Glenlynn', postcode: '6256', lga: 'Shire of Bridgetown-Greenbushes' },
  { name: 'Greenbushes', postcode: '6254', lga: 'Shire of Bridgetown-Greenbushes' },
  { name: 'Hester', postcode: '6255', lga: 'Shire of Bridgetown-Greenbushes' },
  { name: 'Hester Brook', postcode: '6255', lga: 'Shire of Bridgetown-Greenbushes' },
  { name: 'Kangaroo Gully', postcode: '6255', lga: 'Shire of Bridgetown-Greenbushes' },
  { name: 'Kingston', postcode: '6256', lga: 'Shire of Bridgetown-Greenbushes' },
  { name: 'Maranup', postcode: '6256', lga: 'Shire of Bridgetown-Greenbushes' },
  { name: 'North Greenbushes', postcode: '6254', lga: 'Shire of Bridgetown-Greenbushes' },
  { name: 'Sunnyside', postcode: '6256', lga: 'Shire of Bridgetown-Greenbushes' },
  { name: 'Wandillup', postcode: '6256', lga: 'Shire of Bridgetown-Greenbushes' },
  { name: 'Winnejup', postcode: '6255', lga: 'Shire of Bridgetown-Greenbushes' },
  { name: 'Yornup', postcode: '6256', lga: 'Shire of Bridgetown-Greenbushes' },

  { name: 'Bow Bridge', postcode: '6333', lga: 'Shire of Denmark' },
  { name: 'Denmark', postcode: '6333', lga: 'Shire of Denmark' },
  { name: 'Hay', postcode: '6333', lga: 'Shire of Denmark' },
  { name: 'Hazelvale', postcode: '6333', lga: 'Shire of Denmark' },
  { name: 'Kentdale', postcode: '6333', lga: 'Shire of Denmark' },
  { name: 'Kordabup', postcode: '6333', lga: 'Shire of Denmark' },
  { name: 'Mount Lindesay', postcode: '6333', lga: 'Shire of Denmark' },
  { name: 'Mount Romance', postcode: '6333', lga: 'Shire of Denmark' },
  { name: 'Nornalup', postcode: '6333', lga: 'Shire of Denmark' },
  { name: 'Ocean Beach', postcode: '6333', lga: 'Shire of Denmark' },
  { name: 'Parryville', postcode: '6333', lga: 'Shire of Denmark' },
  { name: 'Peaceful Bay', postcode: '6333', lga: 'Shire of Denmark' },
  { name: 'Scotsdale', postcode: '6333', lga: 'Shire of Denmark' },
  { name: 'Shadforth', postcode: '6333', lga: 'Shire of Denmark' },
  { name: 'Tingledale', postcode: '6333', lga: 'Shire of Denmark' },
  { name: 'Trent', postcode: '6333', lga: 'Shire of Denmark' },
  { name: 'William Bay', postcode: '6333', lga: 'Shire of Denmark' },

  { name: 'Balbarrup', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Beedelup', postcode: '6260', lga: 'Shire of Manjimup' },
  { name: 'Boorara Brook', postcode: '6262', lga: 'Shire of Manjimup' },
  { name: 'Broke', postcode: '6398', lga: 'Shire of Manjimup' },
  { name: 'Callcup', postcode: '6260', lga: 'Shire of Manjimup' },
  { name: 'Channybearup', postcode: '6260', lga: 'Shire of Manjimup' },
  { name: 'Collins', postcode: '6260', lga: 'Shire of Manjimup' },
  { name: 'Crowea', postcode: '6262', lga: 'Shire of Manjimup' },
  { name: 'Deanmill', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Diamond Tree', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Dingup', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Dixvale', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Eastbrook', postcode: '6260', lga: 'Shire of Manjimup' },
  { name: 'Glenoran', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Jardee', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Lake Muir', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Linfarne', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Manjimup', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Meerup', postcode: '6262', lga: 'Shire of Manjimup' },
  { name: 'Middlesex', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Mordalup', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'North Walpole', postcode: '6398', lga: 'Shire of Manjimup' },
  { name: 'Northcliffe', postcode: '6262', lga: 'Shire of Manjimup' },
  { name: 'Palgarup', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Pemberton', postcode: '6260', lga: 'Shire of Manjimup' },
  { name: 'Perup', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Quinninup', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Ringbark', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Shannon', postcode: '6262', lga: 'Shire of Manjimup' },
  { name: 'Smith Brook', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Upper Warren', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Walpole', postcode: '6398', lga: 'Shire of Manjimup' },
  { name: 'Wilgarrup', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Windy Harbour', postcode: '6262', lga: 'Shire of Manjimup' },
  { name: 'Yanmah', postcode: '6258', lga: 'Shire of Manjimup' },
  { name: 'Yeagarup', postcode: '6260', lga: 'Shire of Manjimup' },

  { name: 'Barrabup', postcode: '6275', lga: 'Shire of Nannup' },
  { name: 'Biddelia', postcode: '6260', lga: 'Shire of Nannup' },
  { name: 'Carlotta', postcode: '6275', lga: 'Shire of Nannup' },
  { name: 'Cundinup', postcode: '6275', lga: 'Shire of Nannup' },
  { name: 'Darradup', postcode: '6275', lga: 'Shire of Nannup' },
  { name: 'Donnelly River', postcode: '6258', lga: 'Shire of Nannup' },
  { name: 'East Nannup', postcode: '6275', lga: 'Shire of Nannup' },
  { name: 'Jalbarragup', postcode: '6275', lga: 'Shire of Nannup' },
  { name: 'Lake Jasper', postcode: '6260', lga: 'Shire of Nannup' },
  { name: 'Nannup', postcode: '6275', lga: 'Shire of Nannup' },
  { name: 'Peerabeelup', postcode: '6260', lga: 'Shire of Nannup' },
  { name: 'Scott River East', postcode: '6275', lga: 'Shire of Nannup' },

  // Additional localities (verified via Australia Post / ABS ASGS).
  { name: 'Brazier', postcode: '6275', lga: 'Shire of Nannup' },
  { name: 'Southampton', postcode: '6275', lga: 'Shire of Nannup' },
  { name: 'Boallia', postcode: '6284', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Chapman Hill', postcode: '6286', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Kaloorup', postcode: '6280', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Metricup', postcode: '6280', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Walsall', postcode: '6288', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Wilyabrup', postcode: '6280', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Yebble', postcode: '6285', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Yoganup', postcode: '6280', lga: 'Shire of Augusta-Margaret River' },
  { name: 'Wilga West', postcode: '6243', lga: 'Shire of Bridgetown-Greenbushes' },
];

/** Map of UPPER-CASED locality name → postcode (first match wins). */
const BY_UPPER_NAME: Record<string, string> = (() => {
  const m: Record<string, string> = {};
  for (const e of LOCALITY_POSTCODES) {
    const key = e.name.toUpperCase();
    if (!(key in m)) m[key] = e.postcode;
  }
  return m;
})();

/**
 * Look up a postcode for a locality. Accepts any casing; matches the polygon
 * data's upper-case `feature.properties.name` directly.
 */
export function postcodeFor(localityName: string | null | undefined): string | null {
  if (!localityName) return null;
  return BY_UPPER_NAME[localityName.toUpperCase()] ?? null;
}
